import React from 'react';
import { Outlet } from 'react-router-dom';
import { ChatProvider } from '../../contexts/ChatContext';
import NotificheChatSito from './NotificheChatSito';
import { getAssociateData, isAuthenticated } from '../../services/otpAuthService';
import { sezioneVisibile } from '../../utils/sezioniDipendente';

/**
 * Chat associati su tutta l'area riservata (notifiche fase A, 20/10/2026, spec §8 e §16 C1):
 * route di sola struttura, montata una volta sola dentro `AssociatePrivateRoute` attorno a tutte
 * le route `/area-riservata/*`. Il provider resta lo stesso navigando tra le pagine dell'area,
 * così la presenza del sito («in uso») e il socket `/chat` valgono ovunque nell'area, non solo
 * sulla pagina della chat. Il socket si apre solo con la chat disponibile e le regole accettate;
 * con la chat spenta o non disponibile non si apre nulla e nessuna pagina mostra errori.
 * Fuori dall'area (admin, pubblico) il provider non c'è.
 * `NotificheChatSito`: suono, chiusura delle notifiche lette, numero sull'icona e messaggi del
 * service worker (notifiche fase A, spec §10).
 * Il dipendente dello studio usa la chat come il titolare (piano 2, chat per persona) se il titolare
 * gli ha abilitato la sezione `chat`; senza, il provider resta spento: nessuna lettura dello stato e
 * nessun socket.
 */
const ChatAreaRiservata: React.FC = () => (
  <ChatProvider attivo={isAuthenticated() && sezioneVisibile(getAssociateData(), 'chat')}>
    <NotificheChatSito />
    <Outlet />
  </ChatProvider>
);

export default ChatAreaRiservata;
